/**
 * Count the number of keys in an object without expanding it
 */
export default function objectKeyCount(obj: object, pred: (key: string) => boolean = () => true): number {
  let count = 0;
  for (const id in obj) {
    if (obj.hasOwnProperty(id) && pred(id)) {
      count++;
    }
  }
  return count;
}
